import { Task } from '@mxt/zio'
import { ZIO } from '@mxt/zio'
import { pipe } from 'fp-ts/function'
import * as t from 'io-ts'
import { POApi } from '../POApi'
import { BeneficiaryDesignationData, ExcessPremiumSubmission, RequestAuthFormDataSubmit } from './model'
import { SubmissionService } from './SubmissionService'
import { Maybe } from '@mxt/zio/codec'
import * as O from 'fp-ts/lib/Option'

export namespace ExcessPremiumService {
  export const PolicyMessageInfo = t.type({
    messageCode: Maybe(t.string),
    message: Maybe(t.string),
    showMessage: t.boolean,
    data: t.array(t.type({
      messageCode: Maybe(t.string),
      message: Maybe(t.string),
      isBlockSubmit: Maybe(t.boolean),
      isBlockAction: Maybe(t.boolean)
    }))
  })

  export type PolicyMessageInfo = t.TypeOf<typeof PolicyMessageInfo>

  export const getDetail = (policyNum: string): Task<ExcessPremiumSubmission.Detail> =>
    pipe(
      ZIO.zipPar(
        POApi.post(`wf-api/policy/account-balance`)(
          t.type({
            body: t.type({
              accountGroups: t.array(
                t.type({
                  amount: t.number,
                  sacsCode: t.string,
                  sacsType: t.string
                })
              )
            })
          })
        )({
          body: {
            policyNum,
            function: 'TOTAL',
            accountGroups: [
              {
                sacsCode: 'LP',
                sacsType: 'S'
              },
              {
                sacsCode: 'LF',
                sacsType: 'WF'
              },
              {
                sacsCode: 'LP',
                sacsType: 'U'
              },
              {
                sacsCode: 'LX',
                sacsType: 'TF'
              },
              {
                sacsCode: 'LP',
                sacsType: 'PX'
              },
              {
                sacsCode: 'LP',
                sacsType: 'PS'
              },
              {
                sacsCode: 'LX',
                sacsType: 'EX'
              },
              {
                sacsCode: 'LI',
                sacsType: 'MO'
              }
            ]
          }
        }),
        SubmissionService.getFileNetAccess(policyNum),
        getLASMessageForPolicy(policyNum)
      ),
      ZIO.map(([balances, receiptFlag, LASMessage]): ExcessPremiumSubmission.Detail => {
        const excessPremiumAmount = balances.body.accountGroups.reduce((total, e) => total + e.amount, 0)
        const isWN18LASMessage =
          pipe(LASMessage.data.find((x) => x.messageCode === 'WN18'),
            O.fromNullable,
            O.fold(
              () => false,
              (messageItem) => true
            )
          )
        return {
          excessPremiumAmount,
          receiptFlag: receiptFlag,
          isWN18LASMessage: isWN18LASMessage
        }
      })
    )
  export const submit =
    (
      policyNum: string,
      data: ExcessPremiumSubmission.SubmitData,
      documents: BeneficiaryDesignationData.BeneficiaryDocumentFile[]
    ) =>
      (requestauth: RequestAuthFormDataSubmit) =>
        SubmissionService.submit(t.unknown)(
          `wf-api/policy/${policyNum}/excess-premium`,
          { body: data },
          policyNum,
          requestauth,
          documents
        )
  // pipe(
  //   PulseOpsApi.postAuthError()(`wf-api/policy/${policyNum}/excess-premium`)(t.unknown)({
  //     body: data,
  //     otpTransaction: requestauth,
  //     source: SourceType.PULSE4OPS
  //   }),
  //   ZIO.asVoid
  // )
  export const getDataCheckAccess = (policyNum: string): Task<ExcessPremiumSubmission.AccessDataCheck> =>
    pipe(
      ZIO.zipPar(SubmissionService.getPolicy(policyNum), getDetail(policyNum)),
      ZIO.map(
        ([policy, excess]): ExcessPremiumSubmission.AccessDataCheck => ({
          contractStatus: policy.body.status ?? '',
          excessPremium: excess.excessPremiumAmount
        })
      )
    )

  export const getLASMessageForPolicy = (policyNum: string) =>
    pipe(
      POApi.get(`pulseops/api/v1/dao/check-policy-message/${policyNum}`)(
        PolicyMessageInfo
      ),
      ZIO.map((responseData) => {
        return responseData
      })
    )
}
